import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '../../../../../../../../../../../../components';

export interface TrunkedNicRulesWarningModalProps {
  onCancel: VoidFunction;
  onConfirm: VoidFunction;
  showTrunkedNicRulesWarning: boolean;
}

export function TrunkedNicRulesWarningModal({
  onCancel,
  onConfirm,
  showTrunkedNicRulesWarning,
}: TrunkedNicRulesWarningModalProps): ReactElement {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      clickScreenToClose={true}
      heading={t('common.warning')}
      subHeading={t(
        'virtualMachines.edit.networking.confirmTrunkedChange.subheading',
      )}
      loading={false}
      onCancel={onCancel}
      onClose={onCancel}
      onConfirm={onConfirm}
      cancelButtonLabel={t('buttons.cancel')}
      confirmButtonColour="primary"
      confirmButtonLabel={t('buttons.confirm')}
      show={showTrunkedNicRulesWarning}
      size="default"
      testId="networking-trunked-rules-warning-modal"
    />
  );
}
